export const addDecimals = (num) => {
  return (Math.round(num * 100) / 100).toFixed(2);
};

export const updateCart = (state) => {
  // 1. Calculate total price of items after discount
  state.itemsPrice = Number(
    state.cartItems.reduce((acc, item) => {
      const priceAfterDiscount = item.discount
        ? item.price - item.discount
        : item.price;
      return acc + priceAfterDiscount * item.qty;
    }, 0).toFixed(2)
  );

  // 2. Calculate total discount
  state.totalDiscount = Number(
    state.cartItems.reduce((acc, item) => {
      const itemDiscount = item.discount ? item.discount * item.qty : 0;
      return acc + itemDiscount;
    }, 0).toFixed(2)
  );

  // 3. Delivery discount logic based on itemsPrice
  let deliveryDiscount = 0;
  if (state.itemsPrice >= 500 && state.itemsPrice < 1000) {
    deliveryDiscount = 10;
  } else if (state.itemsPrice >= 1000 && state.itemsPrice < 2000) {
    deliveryDiscount = 30;
  } else if (state.itemsPrice >= 2000 && state.itemsPrice < 3000) {
    deliveryDiscount = 50;
  } else if (state.itemsPrice >= 3000 && state.itemsPrice < 5000) {
    deliveryDiscount = 100;
  } else if (state.itemsPrice >= 5000 && state.itemsPrice < 10000) {
    deliveryDiscount = 150;
  } else if (state.itemsPrice >= 10000) {
    deliveryDiscount = 200;
  }
  state.totalDeliveryDiscount = deliveryDiscount;

  // 4. Shipping and tax
  state.shippingPrice = 0;
  state.taxPrice = 0;

  // 5. Final total
  const totalBeforeDiscount = state.itemsPrice + state.shippingPrice + state.taxPrice;
  const totalAfterDiscount = totalBeforeDiscount - deliveryDiscount;
  state.totalPrice = Number(totalAfterDiscount.toFixed(2));

  // ✅ 6. Persist cart items
  localStorage.setItem('cart', JSON.stringify(state));

  return state;
};

